export enum UserAccessRole {
    ACCOUNT_MANAGER = "account_manager",
    ACTIVATION_USER = "activation_user",
    LOCATION_ADMIN = "location_admin",
    LOCATION_ENHANCED_USER = "location_enhanced_user",
    LOCATION_MANAGER = "location_manager",
    LOCATION_USER = "location_user",

    WAITER = "waiter",

    /**
     * User role used for partner integrations with limited access
     */
    PARTNER_USER = "partner_user",

    PARTNER_USER_PREMIUM = "partner_user_premium",

    /**
     * Temporary role used to determinate the users that are in the onboarding process
     */
    ONBOARDING_USER = "onboarding_user",

    CHALLENGES_ACTIVATION_USER = "challenges_activation_user",

    /**
     * Limited account that can only see data related views (benchmark, overview...)
     */
    OUTLETS_USER = 'outlets_user'
}

export const UserAccessRoleValues = Object.values(UserAccessRole);